























import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class ModalSimple extends Vue {
  @Prop({type: String, required: true}) title!: string
}
